import { animate, createTimeline, stagger, splitText } from '../../vendor/anime.esm.js';
import { DURATION, EASE, STAGGER, SPRING_PRESETS, resolveDuration, resolveStagger, BLUR } from '../motion-tokens.js';

export const testimonialsV1 = (el) => {
    const cards = el.querySelectorAll('.testimonial-card, .card, .review-card');
    if (!cards.length) return null;

    cards.forEach(c => { c.style.opacity = '0'; c.style.transform = 'translateX(-25px) rotateY(15deg)'; c.style.filter = BLUR.normal; });

    const container = el.querySelector('section') || el;
    container.style.perspective = '800px';

    return animate(cards, {
        opacity:    [0, 1],
        rotateY:    [15, 0],
        translateX: [-25, 0],
        filter:     [BLUR.normal, BLUR.none],
        delay:      stagger(resolveStagger(STAGGER.normal)),
        duration:   resolveDuration(DURATION.slow),
        ease:       EASE.refined,
    });
};

export const testimonialsV2 = (el) => {
    const quote      = el.querySelector('.quote-icon, .quote-mark, .quote-text::before');
    const textEl     = el.querySelector('p, blockquote, .testimonial-text');
    const line       = el.querySelector('.author-line-wrapper');
    const author     = el.querySelector('[data-field="author"], .author, .testimonial-author');
    const tl = createTimeline({ defaults: { ease: EASE.refined }, });

    if (quote) tl.add(quote, {
        scale:   [0, 1],
        opacity: [0, 1],
        duration: 900,
        ease:    SPRING_PRESETS.magnetic,
    }, 0);

    if (textEl) {
        textEl.style.perspective = '1000px';
        
        try {
            const split = splitText(textEl, { lines: false, words: true, characters: false });
            if (split.words?.length) {
                tl.add(split.words, {
                    opacity:    [0, 1],
                    translateY: [15, 0],
                    rotateY:    [30, 0],
                    delay:      stagger(35, { from: 'start' }),
                    duration:   resolveDuration(DURATION.normal),
                    ease:       EASE.refined
                }, '-=600');
            }
        } catch(e) {
            tl.add(textEl, {
                opacity:    [0, 1],
                translateY: [15, 0],
                duration:   resolveDuration(DURATION.slow),
                ease:       EASE.refined
            }, '-=600');
        }
    }

    if (line) tl.add(line, {
        scaleX:          [0, 1],
        transformOrigin: '50% 50%',
        opacity:         [0, 1],
        duration:        800,
        ease:            'easeOutExpo'
    }, '-=500');

    if (author) tl.add(author, {
        opacity:    [0, 1],
        translateY: [10, 0],
        duration:   resolveDuration(DURATION.normal),
        ease:       SPRING_PRESETS.magnetic
    }, '-=600');

    return tl;
};

export const testimonialsV3 = (el) => {
    const bubbles = [...el.querySelectorAll('.testimonial-card, .bubble, .chat-bubble, .card')];
    if (!bubbles.length) return null;

    return animate(bubbles, {
        opacity:    [0, 1],
        translateX: (el, i) => [i % 2 === 0 ? -30 : 30, 0],
        filter:     ['blur(3px)', 'blur(0px)'],
        delay:      stagger(resolveStagger(STAGGER.normal), { start: 0 }),
        duration:   resolveDuration(DURATION.slow),
        ease:       EASE.refined,
    });
};
